export default __webpack_public_path__ + "static/Plots0018-9879f33207fedfabf65aceddb317d1c3.jpg";